import { Injectable } from "@angular/core";
import { EMPTY, Observable } from "rxjs";
import { CaseDetails } from "../interfaces/case.interface";
import { FileToCase } from "../interfaces/fileToCase.interface";
import { GetHttpHeaders, GetHttpHeadersSimple } from "./serviceUtils";
import { RequestUtilsService } from "./requestUtils";

@Injectable({
    providedIn: "root"
})
export class CreateCaseService {
    constructor(private requestUtils: RequestUtilsService) {}

    createCase(caseDetails: CaseDetails) {
        if (!caseDetails) return EMPTY;
        const url = "incidents";
        let body: { [key: string]: any } = {
            title: caseDetails.title,
            description: caseDetails.description,
            caseorigincode: 3,
            "customerid_account@odata.bind": `accounts(${caseDetails.customerId})`,
            "svk_Account@odata.bind": `accounts(${caseDetails.accountid})`,
            "svk_ReportedBy@odata.bind": `contacts(${caseDetails.reportedBy})`,
            "svk_BusinessArea@odata.bind": `svk_businessareas(${caseDetails.businessArea})`,
            "svk_CaseCategory@odata.bind": `svk_casecategories(${caseDetails.category})`
        };
        if (caseDetails.dueDate) {
            body["svk_duedate"] = `${caseDetails.dueDate}`;
        }

        return this.requestUtils.createPostRequest<any>(url, body, (response) => response, GetHttpHeaders);
    }

    postFileToCE(file: FileToCase): Observable<FileToCase> {
        if (!file) return EMPTY;
        const url = "annotations";
        const body = file;
        return this.requestUtils.createPostRequest<FileToCase>(url, body, (response) => response, GetHttpHeadersSimple);
    }

    // mapper
    mapFileToCase(caseId: string, file: string, filename: string) {
        if (!caseId || !file) return;
        let applicationParts = file.split(";");
        let documentParts = file.split(";base64,");
        const mimetype = applicationParts.length > 1 ? applicationParts[0].split(":")[1] : "";
        const documentBody = documentParts.length > 1 ? documentParts[1] : "";

        const fileToCase: FileToCase = {
            ["objectid_incident@odata.bind"]: `/incidents(${caseId})`,
            subject: `File tilhørende case - ${caseId}`,
            notetext: "Note med vedhæftet fil",
            isdocument: true,
            filename: filename ?? "",
            mimetype: mimetype,
            documentbody: documentBody
        };

        return fileToCase;
    }
}
